<style>
  .PlanejamentoContratoForm {
    margin-bottom: 100px;
  }
  .PlanejamentoContratoForm .card-title {
    font-size: 18px;
    font-weight: 500;
  }
  .PlanejamentoContratoForm .card-subtitle {
    font-size: 16px;
    font-weight: 400;
  }
</style>
<template>
  <div class="PlanejamentoContratoForm" v-if="carregouEstrutura">

    <component v-for="(p, index) in componentesPassos" :key="index"
      :is="p.componente"
      :ref="p.nome"
      v-show="exibePasso(p.componente)"
      :tipo-contrato="tipoContrato"
      :configuracao="configuracao"
      :contrato-edicao="contratoEdicao"
      :edicao="edicao"
      :novo-contrato="novo"
      :alterar-finalizado="alterarFinalizado"
      :is-copia-contrato="copia"
      :somente-leitura="!podeEditar"
      :pode-solicitar-aprovacao-contrato="podeSolicitarAprovacaoContrato"
      :tem-fluxo-contrato="temFluxoContrato"
      :get-objeto-outro-passo="getObjetoOutroPasso"
      :ind-sem-verba="indSemVerba"
      @PlanejamentoContratoForm__AtualizaIndTemEvidencia="atualizaIndTemEvidencia"
      @PlanejamentoContratoForm__VigenciaContratoAlterada="atualizarDatasAcoes"
      @PlanejamentoContratoFormAcoes__carregarContrato="carregarContrato"
      @PlanejamentoContratoFormAcaoes__atualizarStatusContrato="atualizarStatusContrato"
      @PlanejamentoContratoFormCampos__atualizarDatasAcoes="atualizarDatasAcoes"
      @PLANEJAMENTO_CONTRATO_PASSO_ANTERIOR="() => $refs.rodapeAcoes.anterior()"
      @PlanejamentoContratoFormAcoes__setValorContrato="setValorContrato"
      @PlanejamentoContratoFormAcoesControle__indSemVerba="setIndSemVerba">
    </component>

    <div class="PlanejamentoContratoForm_Acoes" v-if="carregouEstrutura">
      <planejamento-contrato-form-rodape
        ref="rodapeAcoes"
        :definicao-passos="definicaoPassos"
        :alterarFinalizado="alterarFinalizado"
        :is-copia-contrato="copia"
        :edicao="edicao"
        :novo="novo"
        :somente-leitura="!podeEditar"
        :contrato-edicao="contratoEdicao"
        :configuracao="configuracao"
        :get-componentes-passos="getComponentesPassos"
        :valida-componente-passo="validaComponentePasso"
        :ind-tem-evidencia="indTemEvidencia"
        :indCancelar="!idContratoFechamento"
        :ind-sem-verba="indSemVerba"
        @PlanejamentoContratoFormRodape__MudaPasso="validaAlteracaoOrigem"
        @PlanejamentoContratoFormRodape__podeSolicitarAprovacaoContrato="preencherPodeSolicitarAprovacaoContrato"
        @PlanejamentoContratoFormRodape__temFluxoContrato="preencherTemFluxoContrato"
        />
    </div>

    <confirm
      ref="origemAlteradaDialog"
      :message="mensagemOrigemAlterada"
      :persistent="true"
      max-width="32em"
      @agree="removerCategoriasPorOrigemAlterada"
      @disagree="reduzirUmPasso">
    </confirm>
    <confirm
      ref="vigenciaAlterada"
      :message="mensagemVigenciaAlterada"
      :persistent="true"
      max-width="32em"
      @agree="mudaPasso()"
      @disagree="reduzirUmPasso">
    </confirm>
    <confirm
      ref="possuiCategoriaInativaDialog"
      :message="mensagemConfirmacaoCategoriaInativa"
      :persistent="true"
      :maxWidth="'700'"
      @agree="confirmaEdicaoContrato"
      @disagree="voltarParaLista"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import { forceLoading, forceHideLoading } from '@/common/functions/loading';
import Confirm from '@/shared-components/dialog/Confirm';
import definicaoPassos from '@/spa/planejamento-contrato/form/planejamentoDefinicaoPassos';
import PlanejamentoContratoFormRodape from '@/spa/planejamento-contrato/form/PlanejamentoContratoFormRodape';
import ContratoConfiguracao from '@/spa/planejamento-contrato/ContratoConfiguracao';

export default {
  components: {
    ...definicaoPassos.componentes,
    PlanejamentoContratoFormRodape,
    Confirm,
  },
  computed: {
    ...generateComputed('CONTRATO', [
      'canEdit',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    tituloTipoContrato() {
      return this.tipoContrato != null ? this.tipoContrato.nome : '';
    },
    subtituloTipoContrato() {
      return this.tipoContrato != null ? this.tipoContrato.descricao : '';
    },
    carregouEstrutura() {
      return this.tipoContrato != null && this.configuracao != null;
    },
    contratoAprovado() {
      return this.statusContrato === 'APROVADO';
    },
    contratoEmCadastro() {
      return this.statusContrato === 'EM_CADASTRO';
    },
    contratoEmAnalise() {
      return this.statusContrato === 'EM_ANALISE';
    },
    podeEditar() {
      return !this.somenteLeitura && !this.contratoAprovado && this.canEdit;
    },
    renderizaFormApuracao() {
      return !this.novo && this.objetoPassoGeral != null && this.contratoEdicao.id != null;
    },
    componentesPassos() {
      return Object.keys(this.passosHabilitados)
        .filter((nome) => this.passosHabilitados[nome].habilitado)
        .map((nome) => ({
          nome,
          componente: this.passosHabilitados[nome].componente,
        }));
    },
    passosHabilitados() {
      return this.definicaoPassos.passosHabilitados(this, this.configuracao.configuracao, this.contratoEdicao);
    },
    indPossuiCategoriaInativa() {
      if (!this.contratoEdicao.passoAcoes || !this.contratoEdicao.passoAcoes.acoes) {
        return false;
      }

      let possuiCategoriaInativa = false;
      this.contratoEdicao.passoAcoes.acoes.forEach((acao) => {
        if (acao.nomeCategoriasInativas && acao.nomeCategoriasInativas.length > 0) {
          possuiCategoriaInativa = true;
        }
      });
      return possuiCategoriaInativa;
    },
    nomeCategoriasInativas() {
      let nome;
      let categoriasInativas = [];
      this.contratoEdicao.passoAcoes.acoes.forEach((acao) => {
        if (acao.nomeCategoriasInativas && acao.nomeCategoriasInativas.length > 0) {
          categoriasInativas.push(...acao.nomeCategoriasInativas.split(';'));
        }
      });
      if (categoriasInativas.length > 0) {
        categoriasInativas = [...new Set(categoriasInativas)];
        nome = categoriasInativas.sort().join(', ');
      }
      return nome;
    },
  },
  props: {
    alterarFinalizado: Boolean,
    copia: Boolean,
    edicao: Boolean,
    novo: Boolean,
    somenteLeitura: Boolean,
    idContratoFechamento: Number,
  },
  data() {
    return {
      tipoContratoResource: this.$api.tipoContrato(this.$resource),
      configuracaoResource: this.$api.planejamentoContratoConfiguracao(this.$resource),
      planejamentoContratoListagemResource: this.$api.planejamentoContratoListagem(this.$resource),
      tipoAcaoResources: this.$api.tipoAcao(this.$resource),
      configuracao: null,
      podeSolicitarAprovacaoContrato: false,
      temFluxoContrato: false,
      tipoContrato: null,
      contratoEdicao: {},
      objetoPassoGeral: null,
      camposDeProdutoDoContrato: null,
      statusContrato: 'EM_CADASTRO',

      passoAberto: 1,
      passoSelecionado: null,
      definicaoPassos,
      indTemEvidencia: false,
      mensagemOrigemAlterada: null,
      mensagemVigenciaAlterada: null,
      mensagemConfirmacaoCategoriaInativa: null,
      indSemVerba: false,
    };
  },
  methods: {
    setIndSemVerba(value) {
      this.indSemVerba = value;
      this.atualizarTiposAcaoPorVerba();
      const passoAcoes = Object.keys(this.passosHabilitados).find((key) => key === 'acoes');
      if (this.$refs[passoAcoes] && this.$refs[passoAcoes][0]) {
        this.$refs[passoAcoes][0].limparCategoriasPorSemVerba();
      }
      if (!this.contratoEdicao.passoAcoes) {
        this.$set(this.contratoEdicao, 'passoAcoes', { acoes: [], categoriasRemovidas: [], acoesRemovidas: [] });
      } else {
        this.contratoEdicao.passoAcoes.acoes = [];
        this.contratoEdicao.passoAcoes.categoriasRemovidas = [];
        this.contratoEdicao.passoAcoes.acoesRemovidas = [];
      }
      if (this.indSemVerba) {
        const tiposAcao = this.configuracao.tiposAcao.filter((tipoAcao) => tipoAcao.indContratoSemVerba);
        if (tiposAcao.length === 0) {
          this.$toast(this.$t('errors.contrato.sem_tipos_acao_sem_verba'));
          this.indSemVerba = false;
          this.atualizarTiposAcaoPorVerba();
        }
      }
    },
    atualizarTiposAcaoPorVerba() {
      const listaTiposAcao = this.podeEditar ? this.configuracao.tiposAcao : this.listaTiposAcaoOriginal;
      if (!listaTiposAcao) return;
      let tiposAcaoFiltrados = [];
      if (this.indSemVerba) {
        tiposAcaoFiltrados = listaTiposAcao.filter((t) => t.indContratoSemVerba);
      } else {
        tiposAcaoFiltrados = listaTiposAcao.filter((t) => !t.indContratoSemVerba);
      }
      this.configuracao.configuracao.passo1.tiposAcao = tiposAcaoFiltrados;
    },
    setValorContrato(valor) {
      this.componentesPassos.filter((c) => this.$refs[c.nome][0].setValorContrato)
        .forEach((c) => this.$refs[c.nome][0].setValorContrato(valor));
    },
    preencherPodeSolicitarAprovacaoContrato(podeSolicitarAprovacaoContrato) {
      this.podeSolicitarAprovacaoContrato = podeSolicitarAprovacaoContrato;
    },
    preencherTemFluxoContrato(temFluxoContrato) {
      this.temFluxoContrato = temFluxoContrato;
    },
    exibePasso(componente) {
      return this.componentesPassos
        .map((p) => p.componente)
        .indexOf(componente) + 1 === this.passoAberto;
    },
    mudaPasso() {
      const passo = this.passoSelecionado;
      if (passo > this.passoAberto) {
        this.avancaPasso(passo);
      }
      this.setarExibeDicaPassoComportamento(passo);
      this.passoAberto = passo;
    },
    reduzirUmPasso() {
      this.$refs.rodapeAcoes.reduzirUmPasso();
    },
    validaAlteracaoOrigem(passo) {
      this.passoSelecionado = passo;
      const proximoPasso = Object.keys(this.passosHabilitados)[passo - 1];
      let alterouOrigem = false;
      const { isTipoContratoSamsung, isTipoContratoEpoca, isTipoContratoNivelFamilia } = this.configuracao;
      let alterouVigencia = false;
      if (proximoPasso === 'acoes' && (this.configuracao.isTipoContratoCartaParceria
        || this.configuracao.isTipoContratoSamsung || this.configuracao.isTipoContratoNivelFamilia || this.configuracao.isTipoContratoEpoca)) {
        alterouOrigem = this.$refs[proximoPasso][0].objetoPassoGeral != null
          && this.$refs[proximoPasso][0].teveOrigemAlterada();
      }
      if (proximoPasso === 'acoes' && !this.copia && (isTipoContratoSamsung
      || isTipoContratoNivelFamilia || isTipoContratoEpoca)) {
        alterouVigencia = this.$refs[proximoPasso][0].objetoPassoGeral != null
          && this.$refs[proximoPasso][0].dataVigenciaContratoAlterada();
      }

      if (passo > this.passoAberto
        && alterouOrigem) {
        const novaOrigem = this.$refs[proximoPasso][0].getNovaOrigem();
        this.mensagemOrigemAlterada = this.$t('message.contrato_origem_alterada', { tipoContrato: this.tipoContrato.nome, nomeGrupoFornecedor: novaOrigem.nomExtensao });
        this.$refs.origemAlteradaDialog.open();
      } else if (passo > this.passoAberto
                && alterouVigencia) {
        this.mensagemVigenciaAlterada = this.$t('message.vigencia_alterada');
        this.$refs.vigenciaAlterada.open();
      } else {
        this.mudaPasso();
      }
    },
    avancaPasso(passo) {
      const ref = Object.keys(this.passosHabilitados)[passo - 1];
      this.$refs[ref][0].abrePasso();
    },
    removerCategoriasPorOrigemAlterada() {
      const passoAcoes = Object.keys(this.passosHabilitados)[this.passoAberto];
      this.$refs[passoAcoes][0].removerCategoriasPorOrigemAlterada();
      this.mudaPasso();
    },
    atualizarDatasAcoes() {
      const { isTipoContratoSamsung, isTipoContratoEpoca, isTipoContratoNivelFamilia } = this.configuracao;
      const passoAcoes = Object.keys(this.passosHabilitados)[this.passoAberto];
      if (this.$refs[passoAcoes] && (isTipoContratoSamsung || isTipoContratoEpoca || isTipoContratoNivelFamilia)) {
        this.$refs[passoAcoes][0].validaVigenciasAcoes();
      } else if (!this.novo) {
        const indDatasAlteradas = true;
        this.$refs[passoAcoes][0].atualizarDatasAcoes(indDatasAlteradas);
      }
    },
    carregarSeUsuarioPossuirAcesso(idContrato) {
      forceLoading();
      this.planejamentoContratoListagemResource.verificarSeUsuarioPossuiAcesso({ idContrato })
        .then((res) => {
          if (res.data) {
            this.carregarContrato(idContrato);
          } else {
            forceHideLoading();
            this.$router.push({ name: 'dashboard-inicial' });
            this.$toast('Acesso negado');
          }
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    carregarContrato(idContrato) {
      this.idContrato = idContrato;

      this.planejamentoContratoListagemResource.buscarContrato({ idContrato })
        .then((res) => {
          this.contratoEdicao = { ...res.data };
          this.indSemVerba = this.contratoEdicao.passoGeral.indSemVerba;
          this.statusContrato = this.contratoEdicao.passoGeral.status;
          return this.contratoEdicao.passoGeral.idContratoTipo;
        }).then((idContratoTipo) => {
          Promise.all([
            this.carregarTipoContrato(idContratoTipo),
            this.carregarConfiguracao(idContratoTipo),
          ]).then(() => {
            if (this.$refs.geral[0]) {
              setTimeout(() => {
                this.$refs.geral[0].montaObjetoContrato();
              });
            }
            if (this.$refs.acoes[0]) {
              setTimeout(() => {
                this.$refs.acoes[0].acoesCarregadas();
              });
            }
            setTimeout(() => this.$refs.rodapeAcoes.carregaInformacoesFluxo(idContrato));
            forceHideLoading();

            if (!this.somenteLeitura && this.canEdit && this.indPossuiCategoriaInativa) {
              this.mensagemConfirmacaoCategoriaInativa = this.$t('message.contrato_possui_categoria_inativa', {
                categoriasInativas: this.nomeCategoriasInativas,
              });
              this.$refs.possuiCategoriaInativaDialog.open();
            }
          });
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    confirmaEdicaoContrato() {
      this.$refs.possuiCategoriaInativaDialog.close();
    },
    voltarParaLista() {
      this.$router.push({ name: 'planejamento-contrato' });
    },
    carregarContratoCopiado(idContrato) {
      this.idContrato = idContrato;

      this.planejamentoContratoListagemResource.buscarContrato({ idContrato })
        .then((res) => {
          this.contratoEdicao = { ...res.data };
          this.indSemVerba = this.contratoEdicao.passoGeral.indSemVerba;
          this.contratoEdicao.passoGeral.status = this.statusContrato;
          return this.contratoEdicao.passoGeral.idContratoTipo;
        }).then((idContratoTipo) => {
          Promise.all([
            this.carregarTipoContrato(idContratoTipo),
            this.carregarConfiguracao(idContratoTipo),
          ]).then(() => {
            if (this.$refs.geral[0]) {
              setTimeout(() => {
                this.$refs.geral[0].montaObjetoContrato();
              });
            }
            if (this.$refs.acoes[0]) {
              setTimeout(() => {
                this.$refs.acoes[0].acoesCarregadas();
              });
            }
            setTimeout(() => this.$refs.rodapeAcoes.carregaInformacoesFluxo(idContrato));
            forceHideLoading();
          });
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    carregarConfiguracao(idTipoContrato) {
      const { idContrato } = this;

      const promise = (!this.novo && !this.copia)
        ? this.configuracaoResource.buscarConfigSnapshot({ idContrato })
        : this.configuracaoResource.buscarConfigVigente({ idTipoContrato });

      return promise.then((res) => {
        this.configuracao = new ContratoConfiguracao(res.data);
        this.listaTiposAcaoOriginal = [...this.configuracao.tiposAcao];

        return this.tipoAcaoResources.buscarAtivosDeContrato().then((response) => {
          const mapaIdTipoAcaoAtivo = response.data.map((tipoAcao) => tipoAcao.id);
          let tiposAcaoAtivas = this.configuracao.tiposAcao.filter((tipoAcao) => mapaIdTipoAcaoAtivo.includes(tipoAcao.idAcaoTipo));
          if (this.indSemVerba) {
            tiposAcaoAtivas = tiposAcaoAtivas.filter((tipoAcao) => tipoAcao.indContratoSemVerba);
          } else {
            tiposAcaoAtivas = tiposAcaoAtivas.filter((tipoAcao) => !tipoAcao.indContratoSemVerba);
          }
          this.configuracao.configuracao.passo1.tiposAcao = tiposAcaoAtivas;
        }, (err) => {
          this.$error(this, err);
        });
      })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    carregarTipoContrato(idTipoContrato) {
      return this.tipoContratoResource.buscarTipoContratoComConfiguracao({ idTipoContrato })
        .then((res) => {
          this.tipoContrato = res.data;
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    validaComponentePasso() {
      const ref = Object.keys(this.passosHabilitados)[this.passoAberto - 1];
      const componente = this.$refs[ref][0];
      if (componente && componente.valida) {
        return componente.valida();
      }
      return true;
    },
    getObjetoOutroPasso(passo) {
      const componente = this.$refs[passo][0];
      if (componente.getObjetoPasso) {
        return componente.getObjetoPasso();
      }
      return null;
    },
    getComponentesPassos() {
      const componentes = [];
      this.componentesPassos.map((c) => c.nome).forEach((ref) => {
        const [referencia] = this.$refs[ref];
        componentes[ref] = referencia;
      });
      return componentes;
    },
    atualizarStatusContrato(statusContrato) {
      this.statusContrato = statusContrato;
      this.$refs.geral[0].setStatusContrato(statusContrato);
    },
    setarExibeDicaPassoComportamento(passo) {
      if (this.passoAberto > passo) {
        const objPassoAberto = Object.keys(this.passosHabilitados)[this.passoAberto - 1];
        if (objPassoAberto === 'acoes') {
          this.$refs[objPassoAberto][0].setarExibeDica(false);
        }
      }
    },
    atualizaIndTemEvidencia(indicador) {
      this.indTemEvidencia = indicador;
    },
  },
  mounted() {
    if (this.$route.params.copy) {
      const idTipoContrato = this.$route.params.contratoCopiado.id_contrato_tipo;
      const idContrato = this.$route.params.id;
      if (!idContrato) {
        this.$router.push({ name: 'planejamento-contrato' });
        return;
      }
      this.carregarContratoCopiado(idContrato, idTipoContrato);
    } else if (this.novo && !this.copia) {
      const { idTipoContrato } = this.$route.params;
      this.carregarTipoContrato(idTipoContrato);
      this.carregarConfiguracao(idTipoContrato);
    } else {
      const idContrato = this.$route.params.idContrato ? this.$route.params.idContrato : this.idContratoFechamento;
      this.carregarSeUsuarioPossuirAcesso(idContrato);
    }
  },
};
</script>
